'use strict';

var React = require('react');

function isValidChild(object) {
  return object == null || React.isValidElement(object);
}

function isReactChildren(object) {
  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
}

module.exports = isReactChildren;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-router/lib/isReactChildren.js
 ** module id = 561
 ** module chunks = 0
 **/